import slRocno from './slRocno'

export default {
  rocno: slRocno,
  app: {
    name: 'Sortiranje',
    tagline: 'Meltal Group',
  },
  general: {
    add: 'Dodaj',
    edit: 'Uredi',
    cancel: 'Prekliči',
    save: 'Shrani',
    delete: 'Izbriši',
    close: 'Zapri',
    back: 'Nazaj',
    yes: 'Da',
    no: 'Ne',
    unknown: 'ni znano',
    kg: 'kg',
    kg_per_hour: 'kg/h',
    people: 'ljudje',
  },
  errors: {
    generic_error: 'Prišlo je do napake',
    network: 'Ni povezave s strežnikom',
    invalid_data: 'Neveljavni podatki',
    not_found: 'Ni najdeno',
    unauthorized: 'Nimaš dostopa',
    duplicate_name: 'Ime že obstaja',
    on_add: 'Napaka pri dodajanju',
    on_edit: 'Napaka pri urejanju',
  },
  success: {
    add: 'Uspešno dodano',
    edit: 'Uspešno posodobljeno',
    delete: 'Uspešno izbrisano',
    entry_saved: 'Vnos shranjen',
    logged_in_operator: 'Prijavljen: {name}',
    logged_in_admin: 'Prijavljen kot administrator',
    pin_changed: 'PIN spremenjen',
    pin_reset: 'Koda za {name} ponastavljena',
    code_chosen: 'Koda je nastavljena',
  },
  lock: {
    locked: 'zaklenjeno',
    choose_who: 'Izberi, kdo si',
    recent: 'Zadnje prijavljeni',
    pick_from_list: 'Nisem med zadnjimi: izberi s seznama',
    pick_from_list_all: 'Izberi s seznama',
    search_placeholder: 'Išči po priimku ...',
    no_results: 'Ni zadetkov',
    admin_login: 'Prijava kot administrator',
    administrator: 'Administrator',
    guide_pdf: 'Navodila za uporabo (PDF)',
    current_pin: 'Vpiši trenutno kodo',
    new_pin: 'Vpiši novo kodo',
    confirm_pin: 'Ponovi novo kodo',
    wrong_pin: 'Napačna koda, poskusi znova',
    pins_dont_match: 'Kodi se ne ujemata, poskusi znova',
    force_title: 'Izberi svojo kodo',
    force_hint: 'Začetna koda je znana vsem. Izberi svojo 4-mestno kodo. Ne sme biti 1234 ali 0000.',
    force_confirm: 'Ponovi svojo kodo',
    pin_not_allowed: 'Te kode ne moreš uporabiti, izberi drugo',
    idle_hint: 'Po 5 minutah brez dotika se program sam zaklene.',
    delete_digit: 'Briši številko',
    keypad: 'Tipkovnica za kodo',
  },
  modules: {
    rocno: 'Ročno',
    rocno_sub: 'Barvne kovine · Zunanje skladišče',
    linija: 'Linija',
    linija_sub: 'Sortirna linija',
    common: 'Skupno',
  },
  nav: {
    home: 'Domov',
    entry: 'Nov vnos',
    overview: 'Pregled',
    log: 'Evidenca',
    stocktake: 'Inventura',
    registries: 'Šifranti',
    guide: 'Navodila',
    audit: 'Sledljivost',
    menu: 'Meni',
    main_menu: 'Glavni meni',
    main_menu_hint: 'Vsi razdelki programa',
  },
  home: {
    title: 'Domov',
    subtitle: 'Izberi, kaj želiš vnesti. Danes je {date}.',
    new_entry: 'Nov vnos',
    rocno_sub: 'Kaj, kdo, koliko časa, ločeno po področjih',
    linija_sub: 'Material, frakcije, kapaciteta in izkoristek',
    guide_title: 'Navodila za uporabo',
    guide_sub: 'Prijava, kako izpolniš vnos in pogosta vprašanja',
    saved: 'Vnos shranjen',
    rocno_today: 'Ročno · danes',
    linija_today: 'Linija · danes',
    to_overview: 'Pregled',
    entries: 'Vnosov',
    qty_in: 'Vhod',
    qty_out: 'Izločeno',
    processed: 'Obdelano',
    capacity: 'Kapaciteta',
    none_today: 'Danes še ni vnosov.',
  },
  session: {
    not_logged_in: 'Ni prijave',
    operator: 'Prijavljen operater',
    administrator: 'Administrator',
    change_pin: 'Spremeni PIN',
    lock: 'Zakleni zaslon',
    color_mode: 'Preklopi svetlo/temno',
  },
  entry: {
    title: 'Nov vnos',
    subtitle: 'Vpiši obdelavo materiala na liniji',
    time_frame: 'Časovni okvir',
    time_frame_hint: 'Ko obdelava enega materiala poteka nepretrgano',
    start: 'Začetek',
    end: 'Konec',
    duration: 'Trajanje (efektivno)',
    capacity: 'Kapaciteta vhoda',
    utilization: 'Izkoristek delovnika',
    outside_schedule_weekend: '{day} ni del rednega delovnika.',
    outside_schedule_partial: 'Vnos delno pade izven rednega delovnika ({day} {start}–{end}).',
    material: 'Obdelovani material',
    material_hint: 'Novega dodaš pod Šifranti',
    qty_in: 'Količina vhoda',
    qty_in_optional: '(neobvezno, če ni znana)',
    qty_in_help: 'Če vhod ni znan, se za izračune privzame vsota izhodnih frakcij (izhod je praviloma vedno stehtan).',
    fractions: 'Izhodne frakcije',
    fractions_hint: 'Kaj je prišlo ven iz obdelanega materiala',
    add_fraction: 'Dodaj frakcijo',
    no_fractions: 'Še ni dodanih frakcij',
    auto_fraction_hint: 'Znak "=" ob frakciji: izračuna razliko med vhodom in ostalimi frakcijami (npr. za ostanek, ki ga ne tehtamo posebej).',
    remainder: 'razlika',
    team: 'Ekipa',
    people_on_line: 'Število ljudi na liniji',
    leader: 'Vodja linije',
    team_members: 'Ekipa (imena)',
    team_members_hint: 'Kdo je bil na liniji',
    no_workers: 'Novega dodaš pod Šifranti',
    notes: 'Opombe',
    notes_optional: 'Neobvezno',
    notes_placeholder: 'npr. krajši zastoj podajalnika ob 13h',
    save: 'Shrani vnos',
  },
  overview: {
    title: 'Pregled',
    subtitle: 'Za analizo vodstva',
    period_week: 'Ta teden',
    period_month: 'Ta mesec',
    period_all: 'Vse',
    total: 'Skupna obdelava',
    total_sub: 'v izbranem obdobju',
    count: 'Št. vnosov',
    count_sub: 'zaključenih ciklov',
    avg_capacity: 'Povp. kapaciteta',
    avg_capacity_sub: 'vhod / efektivni čas',
    avg_people: 'Povp. št. ljudi',
    avg_people_sub: 'na liniji',
    avg_utilization: 'Povp. izkoristek delovnika',
    avg_utilization_sub: 'povprečje po vnosih, ko je linija delala',
    line_utilization: 'Časovni izkoristek linije',
    line_utilization_sub: 'delo / ves razpoložljiv čas v obdobju',
    pct_inferred: 'Delež ocenjenega vhoda',
    pct_inferred_sub: 'vhod ni bil stehtan',
    trend: 'Gibanje obdelave',
    trend_hint: 'Zadnjih 14 dni, ne glede na zgornji filter',
    trend_avg: 'Povprečje na dan z vnosi',
    trend_max: 'Najvišji dan',
    trend_empty: 'V zadnjih 14 dneh še ni vnosov.',
    by_material: 'Po materialu (vhod)',
    by_material_hint: 'Vključuje ocenjeni vhod',
    capacity_by_material: 'Kapaciteta po materialu',
    capacity_by_material_hint: 'Povprečje, kg/h',
    by_fraction: 'Po frakciji (izhod)',
    by_leader: 'Po vodji linije',
    by_leader_hint: 'Vhod (kg)',
    no_data: 'Ni podatkov',
  },
  days: {
    title: 'Pregled po dnevih',
    hint: 'Označi dva dneva za primerjavo. Razširi vrstico za vodje, zaposlene in posamezne vnose. Odstotek ob vhodu in kapaciteti je sprememba glede na prejšnji dan z vnosi.',
    empty: 'V izbranem obdobju ni vnosov.',
    entries: 'Vnosi',
    qty_in: 'Vhod',
    qty_out: 'Izhod',
    hours: 'Efektivne ure',
    capacity: 'Kapaciteta',
    utilization: 'Izkoristek',
    people: 'Ljudje',
    leaders: 'Vodje',
    workers: 'Zaposleni',
    materials: 'Po materialu',
    fractions: 'Po frakciji',
    day_entries: 'Vnosi tega dne',
    details: 'Podrobnosti',
    select_day: 'Izberi dan za primerjavo',
    compare_title: 'Primerjava dnevov',
    compare_hint: 'Razlika = poznejši dan − zgodnejši dan. Cikel čez polnoč se razdeli po dnevih glede na efektivne ure.',
    compare_pick: 'Izberi še en dan za primerjavo.',
    clear_compare: 'Počisti izbiro',
    difference: 'Razlika',
    show_more: 'Prikaži starejše dneve',
  },
  log: {
    title: 'Evidenca',
    subtitle: 'Vsi zabeleženi vnosi',
    all: 'Vse',
    input: 'Vhod',
    output: 'Izhod',
    empty: 'Ni vnosov za izbrani filter.',
    detail_title: 'Podrobnosti vnosa',
    date: 'Datum',
    time: 'Čas',
    material: 'Material',
    duration: 'Trajanje',
    input_qty: 'Vhod',
    capacity: 'Kapaciteta',
    utilization: 'Izkoristek delovnika',
    people: 'Ljudje na liniji',
    leader: 'Vodja linije',
    team_members: 'Ekipa (imena)',
    output_fractions: 'Izhodne frakcije',
    total: 'Skupaj',
    no_fractions: 'Brez vnesenih frakcij',
    notes: 'Opombe',
    estimated: 'ocenjeno',
    estimated_tooltip: 'Ocenjeno iz vsote izhodnih frakcij, ker vhod ni bil vnesen.',
  },
  registries: {
    title: 'Šifranti',
    subtitle: 'Materiali, frakcije, vodje',
    materials: 'Materiali',
    fractions: 'Frakcije',
    leaders: 'Vodje linije',
    leaders_hint: 'Dodaja samo administrator',
    leaders_restricted: 'Za dodajanje ali odstranjevanje vodij se prijavi kot administrator.',
    workers: 'Ekipa (delavci)',
    workers_hint: 'Dodaja samo administrator',
    workers_restricted: 'Za dodajanje ali odstranjevanje delavcev se prijavi kot administrator.',
    operators: 'Operaterji',
    operators_hint: 'Kode niso vidne vsem',
    operators_restricted: 'Kode niso vidne vsem. Za dodajanje, brisanje ali ponastavitev kode se prijavi kot administrator.',
    new_material: 'Nov material...',
    new_fraction: 'Nova frakcija...',
    new_leader: 'Novo ime...',
    new_worker: 'Novo ime in priimek...',
    new_operator_name: 'Ime in priimek...',
    new_operator_pin: 'PIN',
    empty: 'Prazen seznam',
    section_linija: 'Linija',
    section_linija_hint: 'Material, frakcije in ekipa na sortirni liniji',
    section_rocno: 'Ročno',
    section_rocno_hint: 'Dodaja vsak prijavljen, brisati sme samo administrator',
    rocno_materials_bk: 'Materiali: Barvne kovine',
    rocno_materials_bk_hint: 'Skladišče bakra',
    rocno_materials_zs: 'Materiali: Zunanje skladišče',
    rocno_materials_zs_hint: 'Klasični odpad',
    rocno_suppliers: 'Dobavitelji',
    rocno_fractions: 'Frakcije',
    rocno_workers: 'Delavci (sortirci)',
    new_supplier: 'Nov dobavitelj...',
    remove_admin_only: 'Brisanje je samo za administratorja.',
    schedule: 'Delovnik (pon–pet)',
    schedule_hint: 'Uporabljen za predlagane ure vnosa, opozorilo izven delovnika in izračun kapacitete/izkoristka',
    schedule_weekend_note: 'Sobota in nedelja: brez delovnika.',
    lunch_break: 'Malica',
    lunch_break_hint: 'Vsak dan enako. Odšteje se od efektivnega in razpoložljivega časa v izračunih.',
    weekdays: {
      '1': 'Ponedeljek',
      '2': 'Torek',
      '3': 'Sreda',
      '4': 'Četrtek',
      '5': 'Petek',
    },
  },
  guide: {
    title: 'Navodila za uporabo',
    subtitle: 'Kako se prijaviš, narediš vnos in kaj narediš ob težavah.',
    open_pdf: 'Odpri PDF',
    expand_all: 'Razpri vse',
    collapse_all: 'Skrči vse',
  },
  audit: {
    title: 'Sledljivost',
    subtitle: 'Kdo je kaj vnesel ali spremenil, s časom. Samo za administratorja.',
    admin_only: 'Sledljivost je na voljo samo administratorju.',
    period_today: 'Danes',
    period_week: 'Ta teden',
    period_month: 'Ta mesec',
    period_all: 'Vse',
    type_all: 'Vse',
    type_entries: 'Vnosi',
    type_logins: 'Prijave',
    type_management: 'Upravljanje',
    search_placeholder: 'Išči po osebi ali opisu ...',
    by_person: 'Po osebah',
    click_person: 'Klikni osebo za filter',
    filter_person: 'Filter: {name}',
    clear_filter: 'počisti',
    entries_count: 'Vnosi',
    all_actions: 'Vsa dejanja',
    last_activity: 'Zadnja aktivnost',
    no_people: 'V izbranem obdobju ni zapisov.',
    log_title: 'Dnevnik dogodkov',
    records: '{count} zapisov',
    showing_first: 'prikazanih prvih {max}',
    limit_note: 'Prikazanih je prvih {max} zapisov. Za starejše zožaj obdobje ali filter.',
    col_time: 'Čas',
    col_who: 'Kdo',
    col_action: 'Dejanje',
    col_details: 'Podrobnosti',
    open: 'Odpri',
    no_rows: 'Ni zapisov za izbrani filter.',
    actions: {
      login: 'Prijava',
      pin_change: 'Menjava kode',
      sort_entry: 'Vnos Ročno',
      stocktake: 'Inventura',
      line_entry: 'Vnos Linija',
      registry_add: 'Šifrant dodan',
      registry_remove: 'Šifrant odstranjen',
      operator_add: 'Operater dodan',
      operator_remove: 'Operater odstranjen',
      pin_reset: 'Koda ponastavljena',
      schedule_change: 'Delovnik spremenjen',
    },
  },
}
